import {Log} from '@probe.gl/log';

export const log = new Log({id: 'luma.gl'});
